module.exports = __webpack_public_path__ + "static/img/advantageN.e6ef0fbe.jpg";